export const tickets = [
  {
    id: "IT-2025-001",
    title: "VPN Connection Issues",
    submittedBy: "Ashley Palma",
    priority: "High",
    status: "Open",
    category: "Network",
    description: "Unable to connect to company VPN from remote location. Getting timeout error.",
    replies: 3,
    lastUpdated: "2 hours ago"
  },
  {
    id: "IT-2025-002",
    title: "Password Reset Request",
    submittedBy: "Saccharine Elupre",
    priority: "Medium",
    status: "In-progress",
    category: "Account",
    description: "Need to reset my email account password. Unable to access through self-service.",
    replies: 1,
    lastUpdated: "5 hours ago"
  },
  {
    id: "IT-2025-003",
    title: "Software Installation - Adobe Creative Suite",
    submittedBy: "Emily Rodriguez",
    priority: "Low",
    status: "Resolved",
    category: "Software",
    description: "Request for Adobe Creative Suite installation on work laptop.",
    replies: 5,
    lastUpdated: "1 day ago"
  },
  {
    id: "IT-2025-004",
    title: "Laptop Running Slow",
    submittedBy: "James Wilson",
    priority: "Medium",
    status: "Open",
    category: "Hardware",
    description: "Work laptop has been running extremely slow for the past week. Need assistance.",
    replies: 2,
    lastUpdated: "3 hours ago"
  },
  {
    id: "IT-2025-005",
    title: "Email Not Syncing on Mobile",
    submittedBy: "Lisa Anderson",
    priority: "Medium",
    status: "In-progress",
    category: "Mobile",
    description: "Work email not syncing properly on iPhone. Missing recent messages.",
    replies: 4,
    lastUpdated: "6 hours ago"
  }
];
